<template>
  <div class="transactionItem">
    <div class="transactionItem__info">
      <div class="transactionItem__info__orderid">
        <div class="transactionItem__info__orderid__id">
          <p class="small-font">
            Order Date
          </p>
          <h3 class="subhead">
            {{formatDate(item.created)}}
          </h3>
        </div>
      </div>
      <div class="transactionItem__info__number">
        <div class="transactionItem__info__number__campaign">
          <p class="small-font">
            Number of campaign
          </p>
          <h3 class="subhead">
            1 Campaign
          </h3>
        </div>
      </div>
      <div class="transactionItem__info__payment">
        <div class="transactionItem__info__payment__status">
          <p class="small-font">
            Transaction status
          </p>
          <h3 class="subhead" :class="colorStatus(item.state)">
            {{item.state == 'wfp' ? 'waiting for payment' : item.state_display | capitalizing}}
          </h3>
        </div>
        <div class="transactionItem__info__payment__metode">
          <p class="small-font">
            Payment method :
          </p>
          <p class="small-font color-black">
            Bank Transfer
          </p>
        </div>
      </div>
      <div class="transactionItem__info__total">
        <div class="transactionItem__info__total__price">
          <p class="small-font">
            Total price :
          </p>
          <h3 class="subhead">
            {{item.get_price | formatMoney}}
          </h3>
        </div>
      </div>
      <!-- <div class="transactionItem__info__action">
        <router-link v-if="item.status == 'wfp' && !item.no_payment" :to="{name:'orderreceipt', params: { order_id: item.id }}" class="btn-action" target= '_blank'>
          <button class="btn-regular secondary">View Detail</button>
        </router-link>
        <router-link v-if="item.status == 'paid'" :to="{name:'paymentreceipt', params: { receipt_id: item.receipt_id }}" class="btn-action" target= '_blank'>
          <button class="btn-regular secondary">View Receipt</button>
        </router-link>
        <button v-if="item.has_over_campaign && item.status !== 'paid'" class="btn-regular primary btn-action" @click="fixingOrder(item.campaigns)">Fix Now</button>
        <button v-if="!item.has_over_campaign && item.status == 'expired'" class="btn-regular primary btn-action" @click="duplicateOrder(item.id)">Fix Now</button>
        <button v-if="item.no_payment && !item.has_over_campaign" class="btn-regular primary btn-action" @click="toPayment(item.id)">Pay Now</button>
      </div> -->
      <div class="transactionItem__info__dropdown"  @click.stop="toggle">
        <i :class="isOpen ? 'icon-chevronup' : 'icon-chevrondown'"></i>
      </div>
    </div>
    <div class="transactionItem__list" v-if="isOpen">
      <adx-transaction-list :campaign="item" 
      :orderStatus="item.state"/>
    </div>
  </div>
</template>

<script>
import TransactionList from '@/views/Transaction/DigitalAdvertising/TransactionItem/List'


import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-transaction-item',
  components: {
    'adx-transaction-list': TransactionList
  },
  props: {
    item: {
      required: false
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen
    },
    total_price(item) {
      return item.reduce((sum, x) => sum + x.net_price, 0)
    },
    duplicateOrder(itemID){
      (async () => {
        const expired = this.item.campaigns.filter(x => x.get_status);
        let response = await api.post(apiV2.orderDuplicate(itemID), {}, {needToken: true})
        if (response.status == 201) {
          this.toPayment(response.data.order.id)
        } else {
          // console.log(response.message)
        }
      })();
    },
    toPayment(itemID){
      this.$router.push({name:'orderdetail', params: { id: itemID }})
    },
    toCampaignEditor(campaignId) {
      this.$router.push({name:'campaigneditorpage', params: { id: campaignId }})
    },
    gotoDetail(itemID) {
      this.$router.push({name:'orderreceipt', params: { order_id: itemID }})
    },
    colorStatus(status) {
      if (status == 'wfp'){
        return 'color-sunrise'
      }else if(status == 'paid'){
        return 'color-lightgreen'
      }else {
        return 'color-grey '
      }
    },
    payment_method(method) {
      if (method == 'bank_transfer' || method == 'echannel'){
        return 'Bank Transfer'
      } else if (method == 'credit_card'){
        return 'Credit Card'
      }
    },
    formatDate(date) {
      return formatShortDate(date)
    },
    fixingOrder(campaigns) {
      
      (async () => {
        // const campaign_id = {
        //   list_campaign: campaigns.map(x => x.id)
        // }
        let response = await api.post(apiV2.fixOrder(this.item.id), {}, {needToken: true})
        if (response.status == 201) {
          this.$router.push({name:'draft'})
        } else {
          // console.log(response.message)
        }
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>